import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { Typography } from 'antd';
import { LoginWrapper } from './style';
import loginLogo from '../../assets/images/newlog.svg';
import { customBaseUrl, httpGet, httpPost } from '../../store/http';
import GlassCard from '../../components/premium/GlassCard';
import PremiumButton from '../../components/premium/PremiumButton';
import PremiumInput from '../../components/premium/PremiumInput';

const { Paragraph, Title, Text } = Typography;

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [pwarnin, setPwarnin] = useState('');

  const validatePhone = (value) => {
    const phoneValidation = /^([\s()-]*\d[\s()-]*){13}$/;
    if (!value.match(phoneValidation)) {
      setPwarnin('Please enter a valid phone number (2348020000000)');
      return false;
    }
    setPwarnin('');
    return true;
  }

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    setLoading(true);

    // if (!validatePhone(email)) {
    //   setLoading(false);
    //   return;
    // }

    try {
      const res = await httpPost(
        `${customBaseUrl.authUrl}/auth/staff/forgot-password`,
        { loginId: email }
      );

      setLoading(false);
      if (res.success) {
        Swal.fire({
          title: 'OTP Sent',
          text: res.message,
          icon: 'success',
          confirmButtonColor: 'var(--waya-red)'
        }).then((result) => {
          if (result.isConfirmed) {
            localStorage.setItem('email', email);
            navigate('/reset_password');
          }
        });
      } else {
        Swal.fire('Oops!', res.message, 'error');
      }
    } catch (error) {
      setLoading(false);
      Swal.fire('Error', 'Something went wrong. Please try again.', 'error');
    }
  };

  return (
    <LoginWrapper>
      <div className="auth-container" style={{ justifyContent: 'center' }}>
        <div className="auth-form-section" style={{ width: '500px' }}>
          <div className="logo-container" style={{ textAlign: 'center', marginBottom: '32px' }}>
            <img src={loginLogo} alt="WayaBank Logo" />
          </div>

          <GlassCard padding="48px" radius="24px">
            <Title level={2} style={{ textAlign: 'center', marginBottom: '12px', fontWeight: 600 }}>
              Forgot Password
            </Title>
            <Paragraph style={{ textAlign: 'center', marginBottom: '32px', color: 'var(--text-muted)' }}>
              Enter your registered phone number to receive a password reset OTP.
            </Paragraph>

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '24px' }}>
                <PremiumInput
                  size="large"
                  placeholder="login Id"
                  value={email}
                  onChange={(e) => {
                    const val = e.target.value;
                    setEmail(val);
                    // if (val.length >= 13) validatePhone(val);
                  }}
                // onBlur={() => validatePhone(email)}
                />
                {pwarnin && (
                  <Text type="danger" style={{ fontSize: '12px', marginTop: '4px', display: 'block' }}>
                    {pwarnin}
                  </Text>
                )}
              </div>

              <PremiumButton
                type="primary"
                htmlType="submit"
                size="large"
                block
                loading={loading}
                onClick={handleSubmit}
                style={{ height: '48px' }}
              >
                Send Reset Code
              </PremiumButton>

              <div style={{ marginTop: '24px', textAlign: 'center' }}>
                <a href="/login" style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>
                  Back to Sign in
                </a>
              </div>
            </form>
          </GlassCard>
        </div>
      </div>
    </LoginWrapper>
  );
}
